<template>
	<div :class="classes">
		<div class="circle"/>
		<div v-if="textToShow" class="text">{{ textToShow }}</div>
	</div>
</template>

<script>

import _ from "lodash";

const FUN_FACTS = [
	'Wusstest du, dass es in Australien ca. 45 Millionen Kängurus gibt?',
	'Wusstest du, dass Kinder pro Tag etwa 400 Fragen stellen?',
	'Wusstest du, dass die Azteken den Flummi erfunden haben?',
	'Wusstest du, dass man mit einem einzigen Bleistift einen 56 Kilometer langen Strich zeichnen kann?',
	'Wusstest du, dass 2005 in der Sahara Schnee fiel?',
	'Wusstest du, dass du bei 3 Minuten Zähne putzen durchschnittlich 10 Kalorien verlierst?',
	'Wusstest du, dass Koalas Schluckauf bekommen, wenn sie gestresst sind?',
	'Wusstest du, dass der erste Anruf mit einem Mobiltelefon am 3. April 1973 in New York City getätigt wurde?',
	'Wusstest du, dass die Bcuhstbaenrehenifloge in eneim Wrot eagl ist?',
	'Wusstest du, dass ein ausgewachsener Elefant innerhalb von fünf Minuten circa 200 Liter Wasser trinken kann?'
];

export default {
	props: {
		text: {
			type: String,
			required: false,
		},
		inline: {
			type: Boolean,
			required: false,
			default: false,
		},
		small: {
			type: Boolean,
			required: false,
			default: false,
		},
		blockElement: {
			type: Boolean,
			required: false,
			default: true,
		},
		funFact: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	computed: {
		classes ()
		{
			return {
				'd-inline-block': !this.blockElement,
				'loading': true,
				'inline': this.inline,
				'small': this.small,
			};
		},
		textToShow ()
		{
			if (this.text)
			{
				return this.text;
			}

			if (this.funFact && !this.inline)
			{
				return _.first(
					_.shuffle(FUN_FACTS)
				);
			}

			return null;
		}
	},
}
</script>
